import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import VideoReel from "@/components/VideoReel";
import StatsBand from "@/components/StatsBand";
import FeatureCauseForApplause from "@/components/FeatureCauseForApplause";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import SpeakingTopics from "@/components/SpeakingTopics";
import Industries from "@/components/Industries";
import Gallery from "@/components/Gallery";
import Results from "@/components/Results";
import ClientMarquee from "@/components/ClientMarquee";
import Testimonials from "@/components/Testimonials";
import CorporateTestimonials from "@/components/CorporateTestimonials";
import LawEnforcement from "@/components/LawEnforcement";
import ConnectionMoment from "@/components/ConnectionMoment";
import Books from "@/components/Books";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import CauseForApplausePage from "@/pages/CauseForApplausePage";
import DentalSpeakerPage from "@/pages/DentalSpeakerPage";
import PassionBookPage from "@/pages/PassionBookPage";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import { usePageSEO } from "@/hooks/usePageSEO";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const Home = () => {
  usePageSEO({
    title: "Gary Zelesky | Keynote Speaker · Author · The Human Defibrillator",
    description: "Gary Zelesky is a nationally recognized keynote speaker, author, and executive leadership voice with 30+ years of experience helping organizations reignite passion, strengthen culture, and move people to action. Trusted by MasterCard, Boeing, Hilton, Hinman, CareCredit, AAO, and hundreds more.",
    canonical: "https://garyzelesky.com/",
  });

  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div data-testid="home-root" className="bg-[#050505] text-white">
      <Navbar />
      <Hero />
      <ClientMarquee />
      <StatsBand />
      <VideoReel />
      <FeatureCauseForApplause />
      <HowItWorks />
      <About />
      <SpeakingTopics />
      <Industries />
      <Gallery />
      <Results />
      <Testimonials />
      <CorporateTestimonials />
      <LawEnforcement />
      <ConnectionMoment />
      <Books />
      <BookingForm />
      <FAQ />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cause-for-applause" element={<CauseForApplausePage />} />
          <Route path="/dental-keynote-speaker" element={<DentalSpeakerPage />} />
          <Route path="/the-passion-centered-person" element={<PassionBookPage />} />
          <Route path="/admin" element={<AdminDashboard />} />

          {/* Legacy Wix URL redirects (client-side; edge-level 301s should also be added at Cloudflare) */}
          <Route path="/general-4" element={<Navigate to="/" replace />} />
          <Route path="/general" element={<Navigate to="/" replace />} />
          <Route path="/general/*" element={<Navigate to="/" replace />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/blog/*" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<Navigate to="/#about" replace />} />
          <Route path="/services" element={<Navigate to="/#speaking" replace />} />
          <Route path="/speaking-topics" element={<Navigate to="/#speaking" replace />} />
          <Route path="/contact" element={<Navigate to="/#book" replace />} />
          <Route path="/booking" element={<Navigate to="/#book" replace />} />
          <Route path="/book-gary" element={<Navigate to="/#book" replace />} />
          <Route path="/testimonials" element={<Navigate to="/#results" replace />} />
          <Route path="/books" element={<Navigate to="/#books" replace />} />
          <Route path="/dental" element={<Navigate to="/dental-keynote-speaker" replace />} />
          <Route path="/dental-speaker" element={<Navigate to="/dental-keynote-speaker" replace />} />
          <Route path="/cfa" element={<Navigate to="/cause-for-applause" replace />} />
          <Route path="/the-passion-centered-professional" element={<Navigate to="/the-passion-centered-person" replace />} />

          {/* Catch-all → 404 (with noindex meta) */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
